import { createFileRoute } from '@tanstack/react-router';

type AllowedType =
  | 'signup'
  | 'recovery'
  | 'invite'
  | 'magiclink'
  | 'email_change'
  | 'email';

export const Route = createFileRoute('/auth/verify')({
  validateSearch: (search: Record<string, unknown>) => ({
    token_hash: typeof search.token_hash === 'string' ? search.token_hash : '',
    type: typeof search.type === 'string' ? (search.type as AllowedType) : '',
    next: typeof search.next === 'string' ? search.next : '/app',
  }),
});

